// src/components/shared/DaysAgo.js
import React from "react";
import {
    formatTimestamp,
    formatMessageDateSeparator,
} from "../../utils/chatUtils";

const DaysAgo = ({ date, isseprator = false }) => {
    if (!date) return null;
    return (
        <span>
            {isseprator
                ? formatMessageDateSeparator(date)
                : formatTimestamp(date)}
        </span>
    );
};

export default DaysAgo;